import { StackdriverErrorReporter } from 'stackdriver-errors-js';
import * as StackTrace from 'stacktrace-js';
import { GIT_COMMIT_HASH, ERROR_REPORTING_KEY, ERROR_REPORTING_PROJECT, } from '@/define/env';
import { logError } from '@/helpers/logger';
import { singletonScriptState } from '@/utils/window/SingletonScriptState';
class ErrorReporting {
    constructor() {
        this.setUp = () => {
            if (ERROR_REPORTING_KEY && ERROR_REPORTING_PROJECT) {
                window.StackTrace = StackTrace;
                window.addEventListener('DOMContentLoaded', () => {
                    try {
                        const auth = singletonScriptState.auth || {};
                        const user = auth.token || '';
                        const errorHandler = new StackdriverErrorReporter();
                        errorHandler.start({
                            context: {
                                user,
                            },
                            key: ERROR_REPORTING_KEY,
                            projectId: ERROR_REPORTING_PROJECT,
                            version: GIT_COMMIT_HASH,
                        });
                    }
                    catch (e) {
                        logError(e);
                    }
                });
            }
        };
    }
}
export default new ErrorReporting();
